import React from 'react'
import {connect} from "react-redux";

import c from "../etc/Const";

const TSlider = ({lc, sendV}) => {

    const wd = 280;
    const w0 = 30;
    const boxes = 50;
    const ww = 127/boxes;

    function renderSquare(i) {

        let style = {
            cursor: 'default',
            margin: '0',
            padding: '0',
            background: 'var(--inner-background)',
            border: '0px #222333 solid',
            height: c.p1 + 'px',
            //width: bw+'px',
        }

        if (lc.v > i * ww - ww && lc.v > 0) {
            style = {
                ...style,
                background: 'rgba(54,106,190,0.63)',
            }
        }

        if (i === 0 && lc.v > 0) {
            style = {
                ...style,
                background: 'rgba(229,32,32,0.82)',
            }
        }
        if( i === 0) {
            style = {
                ...style,
                width: w0+'px',
            }
        }

        return (
            <th
                className='xhover'
                style={
                    style
                }
                onClick={() => sendV(i * ww)}
                key={i}
            >
            </th>
        );
    }

    let styletable = {
        border: '0 solid',
        borderCollapse: 'collapse',
        emptyCells: 'show',
        margin: '0',
        padding: '0',
    }

    let squares = [];
    for (let i = 0; i <= boxes; i++) {
        squares.push(renderSquare(i));
    }

    let styleunit = {
        width: 'auto',
        margin: '5px',
        padding: '0px',
        border: 'var(--border)',
        borderRadius: 'var(--border-radius)',
        background: 'var(--inner-background)',

    }

    return (

        <div
            style={styleunit}
        >
            <table style={styletable}>
                <tbody>
                <tr>
                    {squares}
                </tr>
                </tbody>
            </table>
        </div>
    );

}

const mapStateToProps = state => {
    return state;
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TSlider)